import ChooseForm from 'components/ChooseInput';
import { FormEvent, useEffect } from 'react';
import {
  Avatar,
  AvatarWrapper,
  ChooseNameWrapper,
  Name,
  Shape,
} from './Start.styles';
import shape from 'assets/icons/nameShape.svg';
import usePersonalAssistant from 'store/usePesonalAssistant';
import Title from 'components/Typography/Title';
import { useTranslation } from 'react-i18next';
import SpeechBox from 'components/SpeechBox';
import useKeyboard from 'store/useKeyboard';
import useUser from 'store/useUser';
import { useNavigate } from 'react-router-dom';
import ClickSound from 'assets/sounds/Tap.wav';
import useSound from 'use-sound';

const ChooseName = () => {
  const { pa } = usePersonalAssistant();
  const [play] = useSound(ClickSound);
  const { hasKeyboard } = useKeyboard();
  const { user, setUser, isLogged, setIsLogged } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    play();
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name: string = formData.get('username') + '';
    setIsLogged(true);
    setUser({
      username: name,
      avatarImage: pa.avatar,
      avatarName: pa.name,
    });
  };

  // useEffect(() => {
  //   if (isLogged) navigate('/map');
  // }, []);

  useEffect(() => {
    if (user?.username && isLogged) navigate('/start/welcome');
    // eslint-disable-next-line
  }, [user]);

  return (
    <ChooseNameWrapper>
      <AvatarWrapper hasKeyboard={hasKeyboard}>
        <Avatar src={pa.avatar} alt="pa-avatar" />
        <Name>
          {!hasKeyboard && (
            <SpeechBox
              className="pt-5 pb-6"
              hasLightBorder={false}
              cornPosition="top"
              width="100%"
            >
              <span className="p-5">
                <Title renderAs="h1" level={1}>
                  {t('askForName')}
                </Title>
              </span>
            </SpeechBox>
          )}
        </Name>
      </AvatarWrapper>
      <ChooseForm handleSubmit={(e) => handleSubmit(e)} />
      <Shape src={shape} />
    </ChooseNameWrapper>
  );
};

export default ChooseName;
